import React from 'react';

import * as Urls from 'src/constants/EndpointUrls';
import {
  HEALTH_INSURANCE_MENU,
  PENSION_INSURANCE_MENU,
  EMPLOYMENT_INSURANCE_MENU,
  ACCIDENT_INSURANCE_MENU
} from 'src/constants/Generals';
import Tag from 'jbc-front/components/Tag';
import styles from './InsuranceSettingMenus.scss';

const InsuranceSettingMenus = ({ activeMenu }) => (
  <div className={styles.wrap}>
    <a href={Urls.CLIENT_HEALTH_INSURANCE_NEW}>
      <Tag active={activeMenu === HEALTH_INSURANCE_MENU && true}>健康保険</Tag>
    </a>
    <a href={Urls.CLIENT_PENSION_INSURANCE_NEW}>
      <Tag active={activeMenu === PENSION_INSURANCE_MENU && true}>厚生年金保険</Tag>
    </a>
    <a href={Urls.CLIENT_EMPLOYMENT_INSURANCE_NEW}>
      <Tag active={activeMenu === EMPLOYMENT_INSURANCE_MENU && true}>雇用保険</Tag>
    </a>
    <a href={Urls.CLIENT_ACCIDENT_INSURANCE_NEW}>
      <Tag active={activeMenu === ACCIDENT_INSURANCE_MENU && true}>労災保険</Tag>
    </a>
  </div>
);

export default InsuranceSettingMenus;
